/**
 * Chat message creation utilities.
 */

import type { ChatMessage } from '../types';
import { MESSAGE_ID_PREFIXES } from '../constants/chatConstants';

/**
 * Creates an error message for display in chat.
 * 
 * @param errorMessage - Error message text
 * @returns ChatMessage object with error content
 */
export function createErrorMessage(errorMessage: string): ChatMessage {
  return {
    id: `${MESSAGE_ID_PREFIXES.ERROR}-${Date.now()}`,
    role: "assistant",
    content: `Error: ${errorMessage}`,
    timestamp: new Date(),
  };
}

/**
 * Creates a user message for display in chat.
 * 
 * @param messageText - User's message text
 * @returns ChatMessage object with user content
 */
export function createUserMessage(messageText: string): ChatMessage {
  return {
    id: `${MESSAGE_ID_PREFIXES.USER}-${Date.now()}`,
    role: "user",
    content: messageText,
    timestamp: new Date(),
  };
}

